// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vPXzD","data":"styles_data__+qWHJ","spin":"styles_spin__adOhu"};